import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "circle-exclamation, error, warning, alert" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.33334 8.00004C1.33334 4.31814 4.31811 1.33337 8.00001 1.33337C11.6819 1.33337 14.6667 4.31814 14.6667 8.00004C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8.00004ZM8.66668 6.01282C8.66668 5.64463 8.3682 5.34615 8.00001 5.34615C7.63182 5.34615 7.33334 5.64463 7.33334 6.01282V8.00898C7.33334 8.37717 7.63182 8.67565 8.00001 8.67565C8.3682 8.67565 8.66668 8.37717 8.66668 8.00898V6.01282ZM8.00001 9.1667C7.53977 9.1667 7.16668 9.5398 7.16668 10C7.16668 10.4603 7.53977 10.8334 8.00001 10.8334C8.46025 10.8334 8.83334 10.4603 8.83334 10C8.83334 9.5398 8.46025 9.1667 8.00001 9.1667Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }